import Mainlayout from "../components/layouts/index";
import CrmMainlayout from "../components/layouts/crm-sidebar/index";
import SMSAutomationPlatform from "../pages/journey";
import MyCampaign from "../pages/campaign";
import WhatsAppInbox from "../pages/chat-box";
import CPaaSDashboard from "../pages/cloud-dashboard";
import DashboardOverview from "../pages/dashboard";
import LandingPage from "../pages/landing";
import SMSCampaignReport from "../pages/report";
import Resellers from "../pages/reseller";
import MessagingRatePage from "../pages/settings";
import WhatsAppTemplateCreator from "../pages/template-creator";
import Dashboard from "../pages/view-campaign";
import WalletScreen from "../pages/wallet";
import WhatsAppSetup from "../pages/channels/whatsapp";
import EmailDashboard from "../pages/channels/email";
import RcsSetupPage from "../pages/channels/rcs/rcs";
import VoiceCommunications from "../pages/channels/voice";
import WebChat from "../pages/channels/web-chat";
import TelegramBot from "../pages/channels/telegram";
import CDP from "../pages/cdp";
import UseCases from "../pages/use-cases";
import AnimatedConnectionFlow from "../pages/connectors";
import SourcesDashboard from "../pages/connectors/connector/sources";
import DestinationsDashboard from "../pages/connectors/connector/destinations";
import AudienceDashboard from "../pages/audience";
import NewAudience from "../pages/audience/new-audience";
import JourneyBuilder from "../pages/journey/new-journey";
import Contact from "../pages/contact";
import AuthGuard from "../utils/auth-guard/route-guard";
import SMSCampaignFlow from "../pages/create-campaign";
import VoiceSetup from "../pages/channels/voice/voice-step";
import MakeOutboundCall from "../pages/channels/voice/call";
import NewConnectionFlow from "../components/marketing/connector/connector";
import AllLeads from "../crm-pages/hot-leads";
import Activities from "../crm-pages/activities";
import CrmContacts from "../crm-pages/contacts";
import ContactDetail from "../crm-pages/contacts/details";
import Deals from "../crm-pages/deal";
import CPaaSDashboardRedirect from "../pages/cloud-dashboard/cpas-redirect";
import ConvoAi from "../crm-pages/convoai";
import CrmDashboard from "../crm-pages/home";
import ConversationDashboard from "../crm-pages/conversation";


// ========== ROUTING CONFIG ========== //
const AppRoutes = [
  // { path: "cpas", element: <ConvoHubPlatform /> },
   { path: "cpas", element: <CPaaSDashboard /> },
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/messaging",
    element: <WhatsAppInbox />,
  },
  
  {
    path: "/",
    element: (
       <AuthGuard>
        <Mainlayout />
      </AuthGuard>
    ),

    children: [
      { path: "/campaigns/create", element:   <SMSCampaignFlow />},
      { path: "cpas-dashboard", element: <CPaaSDashboardRedirect /> },
      { path: "dashboard", element: <DashboardOverview /> },
      { path: "customer", element: <Resellers /> },
      { path: "campaign", element: <MyCampaign /> },
      { path: "view-campaign", element: <Dashboard /> },
      { path: "journeys", element: <SMSAutomationPlatform /> },
      { path: "journey/new", element: <JourneyBuilder /> },
      { path: "campaign-report/:id", element: <SMSCampaignReport /> },
      { path: "whatsapp-setup", element: <WhatsAppSetup /> },
      { path: "template-creator", element: <WhatsAppTemplateCreator /> },
      { path: "email", element: <EmailDashboard /> },
      { path: "rcs-setup", element: <RcsSetupPage /> },
      { path: "voice", element: <VoiceCommunications /> },
      { path: "voice-setup", element: <VoiceSetup /> },
      { path: "webchat-setup", element: <WebChat /> },
      { path: "telegram-setup", element: <TelegramBot /> },
      { path: "settings", element: <MessagingRatePage /> },
      { path: "wallet", element: <WalletScreen /> },
      { path: "cdp", element: <CDP /> },
      { path: "connectors", element: <AnimatedConnectionFlow /> },
      { path: "connectors/sources", element: <SourcesDashboard /> },
      { path: "connectors/destinations", element: <DestinationsDashboard /> },
      { path: "create/connections", element: <NewConnectionFlow /> },
      { path: "use-cases", element: <UseCases /> },
      { path: "audience", element: <AudienceDashboard /> },
      { path: "audience/new", element: <NewAudience /> },
      { path: "contact", element: <Contact /> },
      { path: "make/call", element: <MakeOutboundCall /> },

    ],
  },


  {
    path: "/",
    element: (
       <AuthGuard>
        <CrmMainlayout />
       </AuthGuard>
    ),

    children: [
        { path: "crm/dashboard", element: <CrmDashboard /> },
      { path: "convoAi", element: <ConvoAi /> },
      { path: "chats", element: <ConversationDashboard /> },
      { path: "leads", element: <AllLeads /> },
      { path: "activities", element: <Activities /> },
      { path: "crm/contact", element: <CrmContacts /> },
      { path: "contact/details", element: <ContactDetail /> },
      { path: "deals", element: <Deals /> },
    ],
  },
];

export default AppRoutes;
